import { Decoder, array, iso8601, number, object, string } from "decoders";

export interface Summary {
  sitesMeasurements: SiteMeasurements[];
}

export interface SiteMeasurements {
  site: string;
  purpose: string;
  analyteMeasurement: AnalyteMeasurement[];
}

export interface AnalyteMeasurement {
  analyte: string;
  numberOfSamples: number;
  startDate: Date;
  endDate: Date;
}

const analyteMeasurementDecoder: Decoder<AnalyteMeasurement> = object({
  analyte: string,
  numberOfSamples: number,
  startDate: iso8601,
  endDate: iso8601,
});
const siteMeasurementsDecoder: Decoder<SiteMeasurements> = object({
  site: string,
  purpose: string,
  analyteMeasurement: array(analyteMeasurementDecoder),
});
export const summaryDecoder: Decoder<Summary> = object({ sitesMeasurements: array(siteMeasurementsDecoder) });
